module.exports = __webpack_public_path__ + "media/images/writer/monitor/txt-header@2x-889705821e988c458ea1b46b87ec648c.png";